import MstRackCategoryComponent from '../Components/Master/RackCategory.tsx';
import { getPageFunction, pageEnum } from '../../security/LoginDetail.js';

export default function MstRackCategory(){
    const pageFunction = getPageFunction({pageId : pageEnum.MstRackCategory});
    return (        
        <MstRackCategoryComponent pageFunction={pageFunction} />
    );
}